import Vue from 'vue'
import App from './App.vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import router from './router'
import store from './store'

Sentry.init({
  dsn: 'https://07ebfc2afcc748a3ab9cdfaea7327f30@sentry.io/1431301',
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true,
    }),
  ],
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
